import { TablePattern } from './table-patterns';
// tslint:disable: variable-name


export class SportCategory extends TablePattern {
  entity_id?: number;
  name: string;
  description: string;
  min: number;
  max: number;
  sport_id: number;

  constructor(o?: Partial<SportCategory>) {
    super(o, { int: ['entity_id', 'min', 'max', 'sport_id'] });
  }
}
